export default __webpack_public_path__ + "static/media/Screenshot_from_2021-10-18_13-05-24-removebg-preview.050f84cc.png";